const LOGIN_REQUESTED = 'login_requested';
const LOGIN_SUCCESSFUL = 'login_successful';
const LOGIN_FAILED = 'login_failed';
const LOGIN_CANCELLED = 'login_cancelled';
const LOGOUT = 'logout';

export {LOGIN_REQUESTED, LOGIN_SUCCESSFUL, LOGIN_FAILED, LOGIN_CANCELLED, LOGOUT};